import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";

class LegacyDistribution extends React.Component {

    render() {
        return (
            <LegacyFrame withHeader={false} isPageTitleNeeded={false} customFrameClass ={"custom-frame-container"} pageTitle={"Distribution Rules"} formname={"distributionrules"} customClass={"field-customization-container legacy-settings-viewer"} />
        );
    }
}

export default LegacyDistribution;
